import { Box, Button, Flex, Grid, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <Flex align="center" justify="center" h="100vh" mx="auto" w="90vw">
            <Grid align="center" justify="center">
                <Grid.Col span={{ base: 12, md: 6 }}>
                    <Title
                        fz={{ base: 100, md: 200 }}
                        ta="center"
                        c="secondaryDark"
                    >
                        404
                    </Title>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                    <Flex direction="column" align="center" justify="center">
                        <Box>
                            <Title c="secondaryDark">
                                {t("error.something-get-wrong")}
                            </Title>
                            <Text maw={600} c="primaryDark" size="lg">
                                {t("error.not-found-description")}
                            </Text>
                            <Button
                                onClick={() => navigate("/")}
                                variant="filled"
                                color={"primary"}
                                bg="primaryDark"
                                size="md"
                                mt="xl"
                            >
                                Назад
                            </Button>
                        </Box>
                    </Flex>
                </Grid.Col>
            </Grid>
        </Flex>
    );
};
export default NotFoundPage;
